import { easepick } from '@easepick/core';
import { RangePlugin } from '@easepick/range-plugin';

export default function () {
    const picker = new easepick.create({
        element: document.querySelector('#contact-dates'),
        css: [
            'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
            'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.1/dist/index.css',
            '/css/easepick.css',
        ],
        format: 'DD/MM/YYYY',
        lang: 'pl-PL',
        plugins: [RangePlugin],
        RangePlugin: {
            tooltip: false
        },
    });
}
